export const SET_PROVIDER = 'provider/SET_PROVIDER';
